export const PROVIDERS = ["gmail", "outlook", "apple"] as const;
export type Provider = (typeof PROVIDERS)[number];
export type Result = "pass" | "issue" | "fail";

export const PROVIDER_LABELS: Record<Provider, string> = {
  gmail: "Gmail",
  outlook: "Outlook web",
  apple: "Apple Mail",
};

export const STORAGE_KEY = "email-render-check-addresses-v1";

export const loadAddresses = (): Record<Provider, string> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<Record<Provider, string>>;
      return {
        gmail: parsed.gmail ?? "",
        outlook: parsed.outlook ?? "",
        apple: parsed.apple ?? "",
      };
    }
  } catch {
    // ignore
  }
  return { gmail: "", outlook: "", apple: "" };
};

export type RenderCheck = {
  id: string;
  template_key: string;
  provider: string;
  result: Result | null;
  notes: string | null;
  reviewed_at: string | null;
};
